import { Injectable } from '@angular/core';
import { HttpServices } from './http-service.service';

@Injectable({
  providedIn: 'root'
})
export class WFHistoryService {

  constructor(private http: HttpServices) { }

    // add(transitRequest: TransitRequestDto) {
    //   return this.http.post('Transit/Add', transitRequest);
    // }
    // Update(transitRequest: TransitRequestDto) {
    //   return this.http.post('Transit/Update', transitRequest);
    // }

    getByRequestIdByStepId(requestId: string, stepId: number) {
      return this.http.get('WFHistory/GetByRequestIdByStepId?requestId=' + requestId + '&stepId=' + stepId);
  }

    getByRequestIdByStepIdById(requestId: string, stepId: number, stepHistoryId: any) {
      return this.http.get('WFHistory/GetByRequestIdByStepIdById?requestId=' + requestId + '&stepId=' + stepId + '&historyId=' + stepHistoryId);
    }

    getByRequestIdByStepIdByPenaltyID(requestId: string, stepId: number,penaltyID : any) {
      return this.http.get('WFHistory/GetByRequestIdByStepIdByPenaltyID?requestId=' + requestId + '&stepId=' + stepId+'&penaltyID=' + penaltyID);
  }

    getByRequestIdByStepIdByIdByPenaltyID(requestId: string, stepId: number, stepHistoryId: any,penaltyID : any) {
      return this.http.get('WFHistory/GetByRequestIdByStepIdByIdByPenaltyID?requestId=' + requestId + '&stepId=' + stepId + '&historyId=' + stepHistoryId+'&penaltyID=' + penaltyID);
    }
    // CancelTransit(data:TransitAdminDto) {
    //   return this.http.post('Transit/CancelTransit', data);
    // }

    // CheckDuplicateIMONumber(IMONumber: string) {
    //   return this.http.get('Transit/CheckDuplicateIMONumber?IMONumber=' + IMONumber);
    // }
}
